import { render, staticRenderFns } from "./HelpEdit.vue?vue&type=template&id=b41a36c4&"
import script from "./HelpEdit.vue?vue&type=script&lang=js&"
export * from "./HelpEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports